var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgView1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.232,
    height: 13.135,
    viewBox: "0 0 23.232 13.135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "view_1_",
    "data-name": "view (1)",
    d: "M20.936,27A13.642,13.642,0,0,0,9.32,33.567a13.556,13.556,0,0,0,23.232,0A13.642,13.642,0,0,0,20.936,27Zm0,11.422a4.854,4.854,0,1,1,4.854-4.854A4.861,4.861,0,0,1,20.936,38.422Zm0-8.566a3.712,3.712,0,1,0,3.712,3.712A3.716,3.716,0,0,0,20.936,29.855Zm0,2.284a1.413,1.413,0,0,0-.9.328l-.2.2a1.413,1.413,0,0,0-.328.9.571.571,0,1,1-1.142,0A2.574,2.574,0,0,1,20.936,31a.571.571,0,1,1,0,1.142Z",
    transform: "translate(-9.32 -27)",
    fill: "#fff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView1);
export default __webpack_public_path__ + "static/media/view (1).7585e4eb12cd6a97670d33c3d5f3c0f6.svg";
export { ForwardRef as ReactComponent };